<template>
    <DashboardLayout>
        <Breadcrumb class="breadcrumb" :model="items" />
        <div class="card flex flex-column justify-center pt-4 px-4">
            <div v-if="viewStack.length > 1" class="mb-4">
                <Button label="Back" icon="pi pi-arrow-left" class="p-button-text back-button cursor-pointer "
                    @click="goBack" />
            </div>
            <div v-if="currentView.type === 'list' && (results && results.length)">
                <ResultsList :results="results" @view-feedback="pushView('view-feedback', $event)" />
            </div>
            <div v-if="currentView.type === 'view-feedback'">
                <FeedbackView :result="currentView.data" />
            </div>
            <div v-else-if="currentView.type === 'list' && !(results && results.length)"
                class="flex align-item-center justify-content-center h-full">
                <div class="flex flex-column ">
                    <span class="Caption text-gray-700 text-center"> You don’t have any added results yet, please enroll
                        with tutor to get results</span>
                </div>
            </div>
        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Breadcrumb from 'primevue/breadcrumb';
import Button from "primevue/button";
import ResultsList from '@/components/dashboard/student/results/resultList.vue'
import FeedbackView from '@/components/dashboard/student/results/feedbackView.vue'
import DashboardLayout from "@/layout/DashboardLayout.vue";
import { useAuthStore } from "@/stores/authStore";
import { getExamResults } from "@/api/student";

const authStore = useAuthStore();
const results = ref([]);
const viewStack = ref([
    { type: "list", label: "Results", data: null }
]);
const items = computed(() => {
    return [
        { label: "Dashboard" },
        ...viewStack.value.map(v => ({ label: v.label }))
    ];
});
const currentView = computed(() =>
    viewStack.value[viewStack.value.length - 1]
);
function pushView(type, data) {
    if (type === "view-feedback") {
        viewStack.value.push({ type, label: "Exam Results", data });
    }
}
function goBack() {
    if (viewStack.value.length > 1) {
        viewStack.value.pop();
    }
}

async function fetchResults(){
    const student = authStore.user.userId || authStore.user._id;
    const data = await getExamResults(student);
    results.value = data.data.data;
}
onMounted(() => {
    fetchResults()
})
</script>
<style scoped>
.back-button {
    color: var(--gray-600);
}

.back-button:hover {
    color: var(--gray-600) !important;
    background-color: var(--gray-200) !important;
}

.back-button:active {
    color: var(--gray-600) !important;
}

.Caption {
    color: var(--gray-700);
}

.breadcrumb {
    display: flex !important;
    flex-wrap: wrap !important;
    overflow-x: hidden !important;
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

@media (max-width: 767px) {
    .breadcrumb {
        font-size: 12px;

    }
}
</style>